var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9214,
    cy: 21.7158,
    r: 21.1338,
    fill: "white",
    stroke: "#949494"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9214 20.7148H22.9214V15.7148C22.9214 15.1628 22.4734 14.7148 21.9214 14.7148C21.3694 14.7148 20.9214 15.1628 20.9214 15.7148V20.7148H15.9214C15.3694 20.7148 14.9214 21.1628 14.9214 21.7148C14.9214 22.2668 15.3694 22.7148 15.9214 22.7148H20.9214V27.7148C20.9214 28.2668 21.3694 28.7148 21.9214 28.7148C22.4734 28.7148 22.9214 28.2668 22.9214 27.7148V22.7148H27.9214C28.4734 22.7148 28.9214 22.2668 28.9214 21.7148C28.9214 21.1628 28.4734 20.7148 27.9214 20.7148Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a541e479505a84301081b20d41f197fa.svg";
export { ForwardRef as ReactComponent };